export enum QueryKey {
  GET_PRODUCTS_BY_NAME = 'getProductByName',
  GET_RANDOM_PRODUCT = 'getRandomProduct',
  GET_PRODUCT = 'getProduct'
}
